import React, { createContext, useState, useEffect, useContext } from "react";
import api from "../setupMiddleware";
import useApiLoader from "../Utils/useApiLoader";

const WalletContext = createContext();

export const WalletProvider = ({ children }) => {
  const [balance, setBalance] = useState(null);
  const loading = useApiLoader();

  // Fetch wallet balance initially
  const fetchBalance = async () => {
    try {
      const response = await api.get("/api/user/balance");
      const data = await response.data;
      console.log("balance data", data);
      if (response.status === 200) {
        setBalance(data.balance);
      } else {
        setBalance(0);
      }
    } catch (error) {
      console.error("Error fetching balance:", error);
      setBalance(0);
    }
  };

  // Call on mount
  useEffect(() => {
    fetchBalance();
  }, []);

  // Function to update wallet manually (e.g., after transaction)
  const updateBalance = (amountChange) => {
    setBalance((prev) => (prev ?? 0) + amountChange);
  };

  // Function to refetch from API
  const refreshBalance = () => {
    fetchBalance();
  };

  return (
    <WalletContext.Provider
      value={{ balance, loading, updateBalance, refreshBalance }}
    >
      {children}
    </WalletContext.Provider>
  );
};

// Custom hook for easier usage
export const useWallet = () => useContext(WalletContext);
